import { useEffect } from 'react';

import { useRatesQuery } from '@/api/query';
import { useAppStore } from '@/stores/useAppStore';

import { Rates, Loading, Error } from './views';

export default function Root() {
  const { setToken, token } = useAppStore();
  const { error, isLoading } = useRatesQuery();

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const t = queryParams.get('token');
    setToken(t ?? '');
  }, [setToken]);

  if (isLoading) {
    return <Loading logo bar />;
  }
  if (error || !token) {
    return <Error error={error} />;
  }
  return <Rates />;
}
